import { z } from 'zod';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
// TODO enforce category matches DB enum
const AlertCategory = {
    Home: 'Home',
    Product: 'Product',
    Settings: 'Settings',
};
export const storeAlert = z.object({
    id: z.number(),
    severity: z.union([z.literal('Info'), z.literal('Warning')]),
    category: enumToZodLiteralUnion(AlertCategory),
    // potentially make this an enum
    subject: z.string(),
    message: z.string(),
    url: z.string().nullable(),
    createdOn: z.string(),
    readOn: z.string().datetime().nullable(),
});
export const storeAlertUpdate = storeAlert.pick({
    readOn: true,
});
export const storeAlertCreate = storeAlert.omit({
    id: true,
    createdOn: true,
    readOn: true,
});
//# sourceMappingURL=storeAlert.js.map